import { render, staticRenderFns } from "./tooth.vue?vue&type=template&id=6bef1a44&scoped=true"
import script from "./tooth.vue?vue&type=script&lang=js"
export * from "./tooth.vue?vue&type=script&lang=js"
import style0 from "./tooth.vue?vue&type=style&index=0&id=6bef1a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bef1a44",
  null
  
)

export default component.exports